<div class="algorithm-picker">
  @if (algorithms.length === 0) {
    <div class="empty">
      {{ "feed-algorithms.message.no-available" | translate }}
    </div>
  }

  @for (algorithm of algorithms; track algorithm.id) {
    <app-algorithm-list-card
      [algorithm]="algorithm"
      [selectable]="true"
      [selected]="isSelected(algorithm.id)"
      (selectedChange)="toggle(algorithm, $event)"
    ></app-algorithm-list-card>
  }
</div>
